<template>
  <span>{{ displayNumber }}</span>
</template>

<script>
export default {
  name: 'NumberAnimation',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    duration: {
      type: Number,
      default: 800,
    },
    decimals: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      displayNumber: 0,
      animationFrame: null,
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.animateNumber(Number(newValue));
      },
      immediate: true,
    },
  },
  methods: {
    animateNumber(endValue) {
      const startTime = Date.now();
      const startValue = this.displayNumber;
      const changeValue = endValue - startValue;

      const animate = () => {
        const currentTime = Date.now();
        const elapsed = currentTime - startTime;
        
        if (elapsed < this.duration) {
          // 使用缓动函数让动画更平滑
          const progress = this.easeOutQuart(elapsed / this.duration);
          this.displayNumber = Number((startValue + changeValue * progress).toFixed(this.decimals));
          this.animationFrame = requestAnimationFrame(animate);
        } else {
          this.displayNumber = Number(endValue.toFixed(this.decimals));
        }
      };

      cancelAnimationFrame(this.animationFrame);
      animate();
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationFrame);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/animation/number-animation.vue